import { z } from "zod";

export const providerIntegrationProviderSchema = z.enum(["asana", "wrike"]);
export type ProviderIntegrationProvider = z.infer<
  typeof providerIntegrationProviderSchema
>;

export const providerBotIdentitySchema = z.object({
  enterpriseId: z.string(),
  provider: providerIntegrationProviderSchema,
  displayName: z.string(),
  email: z.string().email(),
  providerUserId: z.string(),
  connectionId: z.string().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type ProviderBotIdentity = z.infer<typeof providerBotIdentitySchema>;

export const providerUserIdentitySchema = z.object({
  enterpriseId: z.string(),
  provider: providerIntegrationProviderSchema,
  providerUserId: z.string(),
  providerEmail: z.string().email().optional(),
  mappedPunttUserId: z.string().nullable().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type ProviderUserIdentity = z.infer<typeof providerUserIdentitySchema>;
